import * as React from "react";
const SvgClose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 15"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeWidth={1.867}
      d="m2.86 12.14 9.28-9.28M2.86 2.86l9.28 9.28"
    />
  </svg>
);
export default SvgClose;
